import styled from "styled-components";

const DetailContainer = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

const Detail = styled.span`
  margin-bottom: 5px;
`;

const DetailContent = styled.span`
  margin-bottom: 5px;
  margin-left: 10px;
`;

const DetailNotice = styled.div`
  margin-bottom: 5px;
  font-weight: bold;
`;

export default {
  DetailContainer,
  Detail,
  DetailContent,
  DetailNotice
};
